import { handleResponse, handleError } from "./apiUtils";
import Config from "../Config";

export async function getSystemPackageDetails(SystemPackageID) {
  return fetch(
    Config.apiUrl +
      "SystemPackage/ById?id=" +
      SystemPackageID,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function getPaymetStatusDetails(CustomMapID) {
  return fetch(
    Config.apiUrl +
      "UserPackagePayment/GetCustomPaymentById?id=" +
      CustomMapID,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export async function postcustomUserPackageCreate(body) {
  return fetch(
    Config.apiUrl +
      "UserPackage/CreateCustomPackagePayment",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body,
    }
  )
    .then(handleResponse)
    .catch(handleError);
}
